import { render, staticRenderFns } from "./headerDc.vue?vue&type=template&id=04aacad0&scoped=true"
import script from "./headerDc.vue?vue&type=script&lang=js"
export * from "./headerDc.vue?vue&type=script&lang=js"
import style0 from "./headerDc.vue?vue&type=style&index=0&id=04aacad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aacad0",
  null
  
)

export default component.exports